import React from "react";
import DailyRates from "../../components/DailyRates";
import { connect } from "react-redux";
import { uploadDailyRates } from "../../Redux/Actions/DailyRates";
import { ProgressBar } from "primereact/progressbar";
import { EzToast } from "../../common/EzToast";
import { getToastProps } from "../../utils/common";
import ConfirmWhileLoading from "../../common/ConfirmWhileLoading";
import { cancelDailyRatesUpload } from "../../Services/business/dailyRatesService";
import { useHistory } from "react-router-dom";

const DailyRatesScreen = (props) => {
  const {
    uploadDailyRates,
    isLoading,
    isUploadDailyRatesSuccess,
    isUploadDailyRatesError,
    screenPermissions
  } = props;
  const history = useHistory();
  const dailyRatesProps = {
    uploadDailyRates,
    isLoading,
    screenPermissions
  };

  return (
    <div>
      {isLoading && (
        <ProgressBar mode="indeterminate" style={{ height: "6px" }} />
      )}
      <ConfirmWhileLoading
        when={isLoading}
        history={history}
        message="Daily rates email is being sent to the customer."
        header="Are you sure you want to quit?"
        onCancelRequest={cancelDailyRatesUpload}
      />
      <EzToast
        {...getToastProps(
          isUploadDailyRatesSuccess,
          isUploadDailyRatesError,
          "Upload daily rates successfully!",
          "Error while uploading daily rates."
        )}
      />
      <DailyRates {...dailyRatesProps} />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    uploadDailyRates: (payload) => dispatch(uploadDailyRates(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    isLoading: selectFromDailyRatesReducer(state, "isLoading"),
    isUploadDailyRatesSuccess: selectFromDailyRatesReducer(state, "isUploadDailyRatesSuccess"),
    isUploadDailyRatesError: selectFromDailyRatesReducer(state, "isUploadDailyRatesError"),
  };
};

const selectFromDailyRatesReducer = (state, path) => {
  return selectDailyRatesReducer(state)[path];
};

const selectDailyRatesReducer = ({ dailyRatesReducer }) => {
  return dailyRatesReducer;
};

export default connect(mapStateToProps, mapDispatchToProps)(DailyRatesScreen);
